export default __webpack_public_path__ + "static/media/detritus2-new-crop.519a1e9b.jpg";